import React, { ReactNode } from 'react'
import { Button, Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import styled from 'styled-components'

type IProps = {
    show: boolean
    cancel(ele): void
    apply(ele): void
    isAppling?: boolean
    hideFooter?: boolean
    children: {
        contentBody?: ReactNode
        contentTitle?: ReactNode
        contentAcceptBtn?: ReactNode
    }
    showCancel?: boolean
    title?: string
}

export const ModalCustom = ({
    show,
    cancel,
    apply,
    children,
    title,
    isAppling = false,
    hideFooter = false,
    showCancel = true
}: IProps): JSX.Element => {
    const { contentBody, contentTitle, contentAcceptBtn } = children
    const RenderTitle = (): JSX.Element => {
        if (contentTitle) return <>{contentTitle}</>

        return (
            <div className="title-message">
                <i className="fas fa-exclamation-circle" /> {title || 'Attention!'}
            </div>
        )
    }

    const RenderBody = (): JSX.Element => {
        if (contentBody) return <>{contentBody}</>

        return <></>
    }

    const RenderAcceptBtn = (): JSX.Element => {
        if (contentAcceptBtn) return <>{contentAcceptBtn}</>

        return <span> Accept </span>
    }

    return (
        <Modal show={show} onHide={() => cancel({})}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <RenderTitle />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <RenderBody />
            </Modal.Body>
            {hideFooter === false && (
                <Modal.Footer>
                    <StyledButton
                        disabled={isAppling}
                        className="btn btn-primary btn accept btn-primary  mr-5"
                        onClick={apply}
                    >
                        <RenderAcceptBtn />
                        {isAppling && <i style={{ marginLeft: 5 }} className="fas fa-spinner fa-spin"></i>}
                    </StyledButton>
                    {showCancel && <Button onClick={cancel}>{i18n('Cancel')}</Button>}
                </Modal.Footer>
            )}
        </Modal>
    )
}

export default ModalCustom

const StyledButton = styled.button`
    &:disabled {
        color: ${({ theme }) => theme['gray-0']};
    }
`
